<template>
<div class="ml-3 credit-card-picker">
    <div class="form-check">
        <input class="form-check-input" type="radio" name="credit_card_type" id="visa" value="visa" @change="$emit('input', $event.target.value)">
        <label class="form-check-label" for="visa">
            <img class="img-thumbnail" width="50" src="/img/visa.png" alt="">VISA
        </label>
    </div>
    <div class="form-check">
        <input class="form-check-input" type="radio" name="credit_card_type" id="amex" value="amex" @change="$emit('input', $event.target.value)">
        <label class="form-check-label" for="amex">
            <img class="img-thumbnail" width="50" src="/img/amex2.png" alt="">American Express (AMEX)
        </label>
    </div>
    <div class="form-check">
        <input class="form-check-input" type="radio" name="credit_card_type" id="mastercard" value="mastercard" @change="$emit('input', $event.target.value)">
        <label class="form-check-label" for="mastercard">
            <img class="img-thumbnail" width="50" src="/img/mastercard.png" alt="">Mastercard
        </label>
    </div>
    <div class="form-check">
        <input class="form-check-input" type="radio" name="credit_card_type" id="discover" value="discover" @change="$emit('input', $event.target.value)">
        <label class="form-check-label" for="discover">
            <img class="img-thumbnail" width="50" src="/img/discover.png" alt="">Discover
        </label>
    </div>
</div>
</template>

<script>
    export default {
        name: "CreditCardTypes"
    }
</script>

<style scoped>

</style>
